import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../styles/CommonDateRangePicker.scss";

// Convert a Date to the `YYYY-MM-DD` string the parent + API expect.
// (react-datepicker hands back a Date object; the API filters on a date string.)
const toISODate = (date) => (date ? date.toLocaleDateString("en-CA") : "");

const CalendarIcon = () => (
  <svg
    className="drp-icon"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

function CommonDateRangePicker({ startDate, endDate, onChange }) {
  const today = new Date(); // no future dates — data only goes up to "today"
  const startObj = startDate ? new Date(startDate) : null;
  const endObj = endDate ? new Date(endDate) : null;

  return (
    <div className="date_range_wrapper">
      <CalendarIcon />

      <DatePicker
        selected={startObj}
        onChange={(date) => onChange({ startDate: toISODate(date), endDate })}
        selectsStart
        startDate={startObj}
        endDate={endObj}
        maxDate={endObj || today}
        dateFormat="dd MMM yyyy"
        placeholderText="Start date"
        className="drp-input"
        calendarClassName="drp-calendar"
        popperClassName="drp-popper"
        wrapperClassName="drp-field"
      />

      <span className="drp-sep" aria-hidden="true">
        →
      </span>

      <DatePicker
        selected={endObj}
        onChange={(date) => onChange({ startDate, endDate: toISODate(date) })}
        selectsEnd
        startDate={startObj}
        endDate={endObj}
        minDate={startObj || null}
        maxDate={today}
        disabled={!startDate}
        dateFormat="dd MMM yyyy"
        placeholderText="End date"
        className="drp-input"
        calendarClassName="drp-calendar"
        popperClassName="drp-popper"
        wrapperClassName="drp-field"
      />
    </div>
  );
}

export default CommonDateRangePicker;
